import { useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { AiOutlineDelete } from 'react-icons/ai';
import { BsListUl } from 'react-icons/bs';
import { FaPlus, FaRegEdit, FaTimes } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ReactTable from '../../../../Components/ReactTable/ReactTable';
import {
  clearTable,
  createTableData,
  deleteTableData,
  editTableData,
  handleSectorTypeListChange,
  createTableSubCategory
} from '../../../../Redux/slices/table';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
// import SingleFormInput from '../components/SingleFormInput';
import { toast } from 'react-toastify';
import SubmitBtn from '../../../../Components/Buttons/SubmitBtn';
import { FormGroup } from '../../../../Components/FormGroup/FormGroup';

function SectorType() {
  const navigate = useNavigate();
  const [singleSector, setSingleSector] = useState(null);
  console.log(singleSector);
  const { id, edit: isEdit } = useParams();
  const [sector_type, setEmployeeType] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const results = useSelector((state) => state.table.results);

  useEffect(() => {
    const getSingleSector = async () => {
      const response = await fetchWrapper.get(`/sector/${id}/`);
      setSingleSector(response.data);
    };
    if (isEdit) {
      getSingleSector();
    }
  }, [id, isEdit]);
  const ShowForm = (check) => {
    if (isEdit) {
      setEmployeeType(false);

      navigate('/admin/settings/sector_type/');
    } else {
      setValue('title', '');
      check = !check;
      check ? setEmployeeType(true) : setEmployeeType(false);
    }
  };
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({ mode: 'onBlur', defaultValues: { title: singleSector?.title } });

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      if (sector_type && !isEdit) {
        let response = await fetchWrapper.post('/sector/', data);
        if (data.parent) {
          dispatch(createTableSubCategory(response.data));
        } else {
          dispatch(createTableData(response.data));
        }
        toast.success(<FormattedMessage id="sector_type_created" />);

        setIsLoading(false);
        setEmployeeType(false);
        navigate('/admin/settings/sector_type/');
      }
      if (isEdit) {
        let response = await fetchWrapper.patch(`/sector/${id}/`, data);
        dispatch(editTableData(response.data));
        toast.success(<FormattedMessage id="sector_type_updated" />);

        setIsLoading(false);
        setEmployeeType(false);

        navigate('/admin/settings/sector_type/');
      }
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  const columns = useMemo(
    () => [
      { Header: <FormattedMessage id="sn" />, accessor: 'serial_number' },
      {
        Header: <FormattedMessage id="category" />,
        accessor: 'title'
      },
      {
        Header: <FormattedMessage id="sub_category" />,
        accessor: 'sub_category'
      },

      {
        Header: <FormattedMessage id="actions" />,
        accessor: 'actions'
      }
    ],
    []
  );

  const handleDelete = async (id) => {
    try {
      await fetchWrapper.delete(`/sector/${id}/`);
      toast.success(<FormattedMessage id="sector_type_deleted" />);
      dispatch(deleteTableData(id));
      navigate('/admin/settings/sector_type/');
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  const handleEdit = (id) => {
    ShowForm(isEdit);
    navigate({ pathname: `${`/admin/settings/sector_type/${id}/edit`}` });
  };

  const data = useMemo(() => {
    if (results) {
      let count = 1;
      return results.map((result) => {
        let action = (
          <div className="d-flex">
            <div className="mx-2">
              <Button variant="outline-success " onClick={() => handleEdit(result.id)}>
                <FaRegEdit />
              </Button>
            </div>
            <div className='"mx-2'>
              <Button variant="outline-danger " onClick={() => handleDelete(result.id)}>
                <AiOutlineDelete />
              </Button>
              <i className={result.icon} />
            </div>
          </div>
        );
        return {
          serial_number: count++,
          title: result.title,
          sub_category: result.sector_childrens.map((item) => item.title).join(','),
          actions: action
        };
      });
    }
  }, [results]);

  const handleEmployeeTypeFetch = ({ index, pageSize }) => {
    dispatch(handleSectorTypeListChange({ index: index, pageSize: pageSize }));
  };
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  const deleteSubCategory = async (id) => {
    try {
      await fetchWrapper.delete(`/sector/${id}/`);
      let tempSubCategory = singleSector.sector_childrens.filter((item) => item.id !== id);
      setSingleSector({ ...singleSector, sector_childrens: tempSubCategory });
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };
  return (
    <div className="card content-section p-3">
      <div className="d-flex justify-content-between align-items-end">
        <h4 className="d-inline-block text-primary">
          <BsListUl size={35} />
          &nbsp;
          <FormattedMessage id="sector_type" />
        </h4>
        <div className="d-flex justify-content-between align-items-end">
          <Button variant="primary" onClick={() => ShowForm(sector_type)} disabled={sector_type}>
            <FaPlus size={18} />
            <FormattedMessage id="add_new" />
          </Button>
        </div>
      </div>
      <hr />
      <div>
        {(isEdit || sector_type) && (
          <>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-6">
                  {/* <SingleFormInput
                    inputType="text"
                    register={register}
                    title="sector_type"
                    id={id}
                    type="sector"
                    errors={errors}
                    isEdit={isEdit}
                    setValue={setValue}
                    defaultValue={sector_type?.title}
                  /> */}
                  <FormattedMessage id="sector_type">
                    {(_sector_type) => (
                      <FormGroup
                        label={_sector_type}
                        placeholder={_sector_type}
                        type="text"
                        id="title"
                        errors={errors}
                        defaultValue={singleSector && singleSector?.title}
                        register={register}
                      />
                    )}
                  </FormattedMessage>

                  {!isEdit && (
                    <FormGroup
                      id="parent"
                      type="select"
                      label={<FormattedMessage id="select_parent" />}
                      register={register}
                      options={results.map((result) => ({ value: result.id, label: result.title }))}
                      placeholder={<FormattedMessage id="select" />}
                      errors={errors}
                      onChange={(value) => {
                        setValue('parent', value.value);
                      }}
                      defaultValue={singleSector?.parent}
                    />
                  )}
                </div>
                {isEdit && (
                  <div className="col-md-6">
                    <p className="fw-bold mb-3">
                      <FormattedMessage id="sub_category" />
                    </p>
                    {singleSector?.sector_childrens?.map((item) => (
                      <div key={item.id} className="d-flex justify-content-between w-50 mb-2">
                        <p>{item.title}</p>
                        <FaTimes
                          className="text-danger cursor-pointer"
                          onClick={() => deleteSubCategory(item.id)}
                        />
                      </div>
                    ))}
                  </div>
                )}
                <div className="d-flex mt-3">
                  <Button
                    variant="danger"
                    className="me-2"
                    onClick={() => {
                      ShowForm(sector_type);
                    }}>
                    <FormattedMessage id="button.cancel" />
                  </Button>
                  <SubmitBtn
                    isLoading={isLoading}
                    buttonText={<FormattedMessage id="button.save" />}
                    icon="none"
                  />
                </div>
              </div>
            </form>
          </>
        )}
      </div>

      <div className="">
        <ReactTable data={data} columns={columns} dataFetcher={handleEmployeeTypeFetch} />
      </div>
    </div>
  );
}

export default SectorType;
